var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-simple-form-box" }, [
    _c("div", { staticClass: "c-simple-form-box__content" }, [
      _c(
        "form",
        { attrs: { novalidate: "" } },
        [
          _c("form-select", {
            attrs: {
              name: "title",
              id: "aboutYouTitle",
              label: _vm.aboutYouTitleLabel,
              options: _vm.titleOptions,
              required: true,
              validationError: _vm.titleError,
              validationMessage: "Please select a title"
            },
            on: {
              change: function($event) {
                return _vm.valueChange($event, "title")
              }
            },
            model: {
              value: _vm.innerTitle,
              callback: function($$v) {
                _vm.innerTitle = $$v
              },
              expression: "innerTitle"
            }
          }),
          _vm._v(" "),
          _vm.showOtherTitle
            ? _c("form-input", {
                attrs: {
                  name: "other-title",
                  id: "aboutYouOtherTitle",
                  label: _vm.aboutYouOtherTitleLabel,
                  required: true,
                  validationError: _vm.otherTitleError,
                  validationMessage: "Please enter a title"
                },
                on: {
                  input: function($event) {
                    return _vm.valueChange($event, "otherTitle")
                  }
                },
                model: {
                  value: _vm.innerOtherTitle,
                  callback: function($$v) {
                    _vm.innerOtherTitle = $$v
                  },
                  expression: "innerOtherTitle"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("form-input", {
            attrs: {
              name: "name",
              id: "aboutYouFirstName",
              label: _vm.aboutYouFirstNameLabel,
              required: true,
              validationError: _vm.firstNameError,
              validationMessage: "Please enter a first name"
            },
            on: {
              input: function($event) {
                return _vm.valueChange($event, "firstName")
              }
            },
            model: {
              value: _vm.innerFirstName,
              callback: function($$v) {
                _vm.innerFirstName = $$v
              },
              expression: "innerFirstName"
            }
          }),
          _vm._v(" "),
          _c("form-input", {
            attrs: {
              name: "surname",
              id: "aboutYouSurname",
              label: _vm.aboutYouSurnameLabel,
              required: true,
              validationError: _vm.surnameError,
              validationMessage: "Please enter a surname"
            },
            on: {
              input: function($event) {
                return _vm.valueChange($event, "surname")
              }
            },
            model: {
              value: _vm.innerSurname,
              callback: function($$v) {
                _vm.innerSurname = $$v
              },
              expression: "innerSurname"
            }
          }),
          _vm._v(" "),
          _c("form-input", {
            attrs: {
              name: "email",
              id: "aboutYouEmail",
              required: true,
              label: _vm.aboutYouEmailLabel,
              validationError: _vm.emailError,
              validationMessage:
                "Please enter a valid email address (e.g. example@wessexwater.co.uk)"
            },
            on: {
              input: function($event) {
                return _vm.valueChange($event, "email")
              }
            },
            model: {
              value: _vm.innerEmail,
              callback: function($$v) {
                _vm.innerEmail = $$v
              },
              expression: "innerEmail"
            }
          }),
          _vm._v(" "),
          _c("form-input", {
            attrs: {
              name: "mobile-phone",
              type: "tel",
              autocomplete: "mobile tel",
              id: "aboutYouPrimaryContact",
              label: _vm.aboutYouPrimaryContactLabel,
              required: true,
              validationError: _vm.primaryContactError,
              validationMessage:
                "Please enter a phone number containing numbers only with no spaces"
            },
            on: {
              input: function($event) {
                return _vm.valueChange($event, "primaryContact")
              }
            },
            model: {
              value: _vm.innerPrimaryContact,
              callback: function($$v) {
                _vm.innerPrimaryContact = $$v
              },
              expression: "innerPrimaryContact"
            }
          }),
          _vm._v(" "),
          _c("form-input", {
            attrs: {
              name: "home-phone",
              type: "tel",
              autocomplete: "home tel",
              id: "aboutYouSecondaryContact",
              label: _vm.aboutYouSecondaryContactLabel,
              validationError: _vm.secondaryContactError,
              validationMessage:
                "Please enter a phone number containing numbers only with no spaces"
            },
            on: {
              input: function($event) {
                return _vm.valueChange($event, "secondaryContact")
              }
            },
            model: {
              value: _vm.innerSecondaryContact,
              callback: function($$v) {
                _vm.innerSecondaryContact = $$v
              },
              expression: "innerSecondaryContact"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "c-summary-box__actions" }, [
            _c(
              "button",
              {
                staticClass: "c-button c-button--brand c-button--text-center",
                attrs: { type: "button" },
                on: { click: _vm.resetForm }
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.backButtonText) + "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "c-button c-button--brand c-button--text-center",
                attrs: { type: "submit" },
                on: { click: _vm.checkForm }
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.continueButtonText) + "\n        "
                )
              ]
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26eb2018", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26eb2018","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/report-a-problem/_vue/FormBox.vue
// module id = 688
// module chunks = 0